import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperLibraryStore from "./DataMapperLibraryStore";

const libraryStore = (rootStore: RootStore) =>
  rootStore.dataMapperLibraryViewStore as DataMapperLibraryStore;

/**
 * Data Mapper → Library: the open profile's schemas and lookup tables, grouped
 * by scope. Read-only in this slice; the editors come later. Gated like the
 * Profiles route (see dataMapperProfiles.Route.ts).
 */
const dataMapperLibraryRoute: RouteType[] = [
  {
    name: "Data Mapper Library",
    path: "/data-mapper/library",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Schemas & Lookup Tables",
        enableRefreshButton: true,
        component: () => import("./DataMapperLibrary.Header"),
      },
      body: {
        component: () => import("./DataMapperLibrary.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper schemas", "lookup tables", "target schemas"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void libraryStore(rootStore)?.load();
    },
    onExit: ({ rootStore }) => {
      libraryStore(rootStore)?.reset();
    },
  },
];

export default dataMapperLibraryRoute;
